import { render, staticRenderFns } from "./dr-stepper.vue?vue&type=template&id=f0cf4542&"
import script from "./dr-stepper.vue?vue&type=script&lang=js&"
export * from "./dr-stepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports